var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button"},[_c('van-button',{attrs:{"type":_vm.type,"plain":_vm.plain,"disabled":_vm.disabled,"loading":_vm.loading,"loadingText":_vm.loadingText},on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }